import React, { useState } from 'react';
import { villaData } from '../data/mockData';
import { X } from 'lucide-react';

export const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  
  return (
    <div className="min-h-screen pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Foto Qalereyası
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Villa və imkanlarının fotoşəkilləri
          </p>
        </div>
        
        {/* Gallery Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {villaData.photos.map((photo, index) => (
            <div
              key={index}
              className="relative group cursor-pointer overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300"
              onClick={() => setSelectedImage(photo)}
            >
              <img
                src={photo}
                alt={`Villa photo ${index + 1}`}
                className="w-full h-80 object-cover transform group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <p className="text-white p-4 font-medium">Foto {index + 1}</p>
              </div>
            </div>
          ))}
        </div>
        
        {/* Lightbox Modal */}
        {selectedImage && (
          <div
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
          >
            <button
              className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
              onClick={() => setSelectedImage(null)}
            >
              <X className="w-8 h-8" />
            </button>
            <img
              src={selectedImage}
              alt="Full size"
              className="max-w-full max-h-full object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
        
        {/* Additional Info */}
        <div className="mt-16 bg-gradient-to-br from-green-50 to-blue-50 rounded-2xl p-8 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Daha çox şəkil görmək istəyirsiniz?
          </h2>
          <p className="text-gray-600 mb-6">
            Bizimlə əlaqə saxlayın, sizin üçün daha çox foto və video göndərə bilərik
          </p>
          <a
            href={`https://wa.me/${villaData.whatsapp.replace(/[^0-9]/g, '')}?text=Salam, daha çox foto görmək istəyirəm`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
          >
            WhatsApp ilə yazın
          </a>
        </div>
      </div>
    </div>
  );
};